import React, { useState } from "react";
import "./trivvyCommonComponents.css";
import { Modal, ModalBody, ModalHeader, Row, Col } from "reactstrap";
import { LuLanguages } from "react-icons/lu";
import {
  TRIVVY_LANGUAGE_SOURCE_NOTE,
  TRIVVY_LANGUAGES,
} from "../../pages/trivia/data";
// Reuses the Create Trivvy modal's design system. This <Modal> is portalled to
// <body>, so it sits OUTSIDE the .bwai-modal dialog that opened it and has to
// carry the root class itself to pick the styles up.
import "../../pages/trivia/Components/CreateTrivia/createTrivia.css";

export default function SupportedLanguagesText({
  showDataTrivvytext,
  invalidTranslationPlan,
  noTranslationLanguage,
}) {
  const [languagesModal, setLanguagesModal] = useState(false);

  return (
    <div className="mb-2">
      {languagesModal && (
        <Modal size="sm" isOpen={true} className="bwai-modal bwai_languages_modal">
          <ModalHeader
            toggle={() => {
              setLanguagesModal(false);
            }}
            className={"bwai_modal_header"}
          >
            <span className="bwai_title_chip is-tint-neutral">
              <LuLanguages />
            </span>
            <span className="bwai_title_text">Supported Languages</span>
          </ModalHeader>
          <ModalBody>
            <Row className="bwai_languages_grid">
              {TRIVVY_LANGUAGES.map((x, index) => (
                <Col md={3} xs={6} key={index}>
                  {x.label}
                </Col>
              ))}
            </Row>
          </ModalBody>
        </Modal>
      )}
      {showDataTrivvytext ? (
        <span className="language-support-text">
          {TRIVVY_LANGUAGE_SOURCE_NOTE}{" "}
          <span
            className="click-here-link-text"
            onClick={() => {
              setLanguagesModal(true);
            }}
          >
            Click here
          </span>{" "}
          to see other supported languages, if not in English.
         
        </span>
      ) : invalidTranslationPlan ? (
        <span className="">
          Sorry, this item doesnt appear to be in English. Either please upload
          it in English OR upgrade so that you may create trivvys in one of our{" "}
          <span
            className="click-here-link-text"
            onClick={() => {
              setLanguagesModal(true);
            }}
          >
            accepted language
          </span>{" "}
        </span>
      ) : noTranslationLanguage ? (
        <span className="">
          Sorry, this item doesnt appear to be in one of our{" "}
          <span
            className="click-here-link-text"
            onClick={() => {
              setLanguagesModal(true);
            }}
          >
            accepted languages
          </span>
          . Please upload this item in one of those languages. Thank you{" "}
        </span>
      ) : (
        <span className="language-support-text">
          Note: If document is not in English,{" "}
          <span
            className="click-here-link-text"
            onClick={() => {
              setLanguagesModal(true);
            }}
          >
            Click here
          </span>{" "}
          to see other supported languages.{" "}
        </span>
      )}
    </div>
  );
}
